<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <div class="row">
        <p
          v-if="usuario.id == undefined"
          class="text-h6 text-brand-1 text-weight-bolder"
        >
          Usuários
        </p>
        <p v-else class="text-h6 text-brand-1 text-weight-bolder">
          Detalhes do Usuário
        </p>
        <p
          v-if="usuario.id"
          class="q-ml-sm text-h6 text-brand-1 text-weight-bolder"
        >
          - {{ usuario.name }}
        </p>
      </div>

      <span
        style="cursor: pointer"
        class="row justify-end q-mt-md q-mb-md"
        @click="backPage"
      >
        <div class="row align-center">
          <q-icon
            label="voltar"
            color="grey"
            class="q-mr-sm"
            size="sm"
            name="west"
          />
          <span style="color: #8a8a8a; font-size: 20px">Voltar</span>
        </div>
      </span>
    </div>
    <p v-if="usuario.id" class="text-brand-1">
      As informações de usuário estão agrupadas por categoria, utilize as abas
      para navegar entre elas.
    </p>
    <div v-if="usuario.id == undefined" class="q-ml-md">
      <p class="text-brand-1 texto-titulo-input-simplificado">
        Utilize o botão abaixo para cadastrar um novo usuário
      </p>
      <q-btn
        icon="add"
        no-caps
        style="border-radius: 8px"
        color="brand-1"
        label="Cadastrar Usuário"
        @click="cadastrarRoute"
      />
    </div>

    <div
      v-if="usuario.id == undefined"
      class="row q-ml-md q-mt-lg col-12 text-brand-5 text-weight-bold"
    >
      <div class="col-md-8 col-sm-8 col-xs-8">
        <div class="q-ml-sm q-mb-sm texto-titulo-input-simplificado">
          Selecione um usuário que deseja consultar.
        </div>
        <section class="row no-wrap">
          <q-select
            v-model="usuario"
            :options="listaUsuariosOptions"
            dense
            outlined
            class="select col-9 input-new-design"
            use-input
            label="Digite o nome do colaborador"
            option-label="name"
            option-value="id"
            input-debounce="0"
            @filter="filterFn"
          />
          <q-btn
            icon="fingerprint"
            no-caps
            class="q-ml-sm"
            style="border-radius: 8px; min-width: 180px"
            color="brand-1"
            label="Usar Biometria"
            v-if="false"
            @click="biometria = !biometria"
          />
        </section>
      </div>
    </div>

    <div v-if="usuario.id">
      <div class="row col-12 q-mt-lg">
        <q-tabs
          v-model="tab"
          style="padding: 0px; margin: 0px"
          dense
          class="q-mt-xl col text-grey-7"
          active-color="black"
          no-caps
          active-bg-color="brand-11"
          indicator-color="transparent"
          align="justify"
        >
          <q-tab
            style="background-color: #d9d9d9; border-radius: 4px"
            name="informacoesUsuario"
            label="Informações do Usuário"
          />
          <q-tab
            v-if="temPermissaoBiometria"
            style="background-color: #d9d9d9; border-radius: 4px"
            class="q-ml-sm q-mr-sm"
            name="biometria"
            label="Biometria"
          />
          <q-tab
            v-if="temPermissaoFacial"
            style="background-color: #d9d9d9; border-radius: 4px"
            class="q-ml-sm q-mr-sm"
            name="biometriaFacial"
            label="Facial"
          />
          <q-tab
            v-if="temPermissaoRetiradaTablet"
            style="background-color: #d9d9d9; border-radius: 4px"
            name="retiradaTablet"
            label="Retirada Tablet"
          />
        </q-tabs>
      </div>
      <q-tab-panels class="row col-12" v-model="tab">
        <q-tab-panel name="informacoesUsuario">
          <div class="row col-12 q-mt-lg">
            <q-tabs
              v-model="tab2"
              style="padding: 0px; margin: 0px"
              dense
              class="q-mt-xl col text-grey-7"
              active-color="black"
              no-caps
              active-bg-color="brand-11"
              indicator-color="transparent"
              align="justify"
            >
              <q-tab
                style="background-color: #d9d9d9; border-radius: 4px"
                name="informacoesBasica"
                label="Informações Básicas"
              />
              <q-tab
                style="background-color: #d9d9d9; border-radius: 4px"
                class="q-ml-sm q-mr-sm"
                name="unit/center"
                label="Unidade / Centro de Custo"
              />
              <q-tab
                style="background-color: #d9d9d9; border-radius: 4px"
                class="q-ml-sm q-mr-sm"
                name="group/tools"
                label="Grupos de Produto / Ferramentas"
              />
              <q-tab
                style="background-color: #d9d9d9; border-radius: 4px"
                name="training"
                label="Treinamentos"
              />
            </q-tabs>
          </div>

          <q-tab-panels class="row col-12 q-mt-xl" v-model="tab2">
            <q-tab-panel name="informacoesBasica">
              <EdicaoInformacoesUsuario
                :id="usuario.id"
                @usuario-inativado="onUsuarioInativado"
              />
            </q-tab-panel>

            <q-tab-panel name="unit/center">
              <TabsCentrosUnidades :id="usuario.id" />
            </q-tab-panel>
            <q-tab-panel name="group/tools">
              <TabsFerramentaGrupo :id="usuario.id" />
            </q-tab-panel>
            <q-tab-panel name="training">
              <TabsTreinamentos :id="usuario.id" />
            </q-tab-panel>
          </q-tab-panels>
        </q-tab-panel>
        <q-tab-panel name="biometria">
          <BiometriaUsuario class="q-mt-md" :id="usuario.id" />
        </q-tab-panel>
        <q-tab-panel name="biometriaFacial">
          <div
            class="q-mb-lg q-mt-md q-ml-md text-brand-1 text-weight-bold"
            style="font-size: 16px"
          >
            Gestão de Biometria Facial do Usuário
          </div>

          <div class="row col-12 q-mt-lg">
            <q-tabs
              v-model="tabFacial"
              style="padding: 0px; margin: 0px"
              dense
              class="q-mt-xl col-5 text-grey-7"
              active-color="black"
              no-caps
              active-bg-color="brand-11"
              indicator-color="transparent"
              align="justify"
            >
              <q-tab
                style="background-color: #d9d9d9; border-radius: 4px"
                name="cadastrarFacial"
                label="Cadastrar Facial"
              />
              <q-tab
                style="background-color: #d9d9d9; border-radius: 4px"
                class="q-ml-sm"
                name="faciaisCadastradas"
                label="Faciais Cadastradas"
              />
            </q-tabs>
          </div>

          <q-tab-panels class="row col-12 q-mt-xl" v-model="tabFacial">
            <q-tab-panel name="cadastrarFacial">
              <ComponenteBiometriaFacial
                class="q-mt-md q-ml-md"
                :isFacial="tab == 'biometriaFacial' ? true : false"
                :idUsuario="usuario.id"
                :tipoMetodo="'cadastro'"
                @atualizarBiometrias="atualizarFaciaisCadastradas"
              />
            </q-tab-panel>

            <q-tab-panel name="faciaisCadastradas">
              <div class="q-mt-md q-ml-md">
                <div class="row col-12 q-mb-md">
                  <p class="text-h6 text-brand-5 text-weight-bold">
                    Biometrias Faciais Cadastradas:
                  </p>
                </div>

                <q-btn
                  dense
                  flat
                  label="Deletar Imagens"
                  icon="delete"
                  color="negative"
                  size="sm"
                  class="row justify-end q-mt-md q-mb-md"
                  @click="deletarFacialDialog = true"
                />

                <span
                  v-if="faciaisCadastradas.length == 0"
                  class="q-mt-lg"
                  style="
                    background-color: red;
                    padding: 15px;
                    color: white;
                    font-weight: bold;
                    border-radius: 5px;
                    display: flex;
                    font-size: 20px;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    margin-top: 125px;
                  "
                >
                  <span>
                    Não existem biometrias faciais cadastradas neste usuário
                  </span>
                </span>

                <div class="row q-col-gutter-md">
                  <div
                    class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
                    v-for="(imagem, index) in faciaisCadastradas"
                    :key="index"
                  >
                    <q-card class="q-pa-sm">
                      <div class="relative-position">
                        <q-img
                          :src="imagem.imagemAssinada"
                          fit="contain"
                          class="rounded-borders"
                          style="height: 200px; background-color: #f5f5f5"
                          spinner-color="primary"
                        />
                      </div>
                      <div class="row justify-around items-center">
                        <q-btn
                          dense
                          flat
                          label="Visualizar Imagem"
                          icon="visibility"
                          color="positive"
                          size="sm"
                          @click="
                            visualizarImagemFacial(
                              imagem.imagem_original,
                              index
                            )
                          "
                        />
                        <div class="column justify-center items-center q-mt-sm">
                          <span>{{
                            imagem?.created_at
                              ?.split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("/")
                          }}</span>
                          <span>{{ imagem?.created_at?.split(" ")[1] }}</span>
                        </div>
                      </div>
                    </q-card>
                  </div>
                </div>
              </div>
            </q-tab-panel>
          </q-tab-panels>
        </q-tab-panel>
        <q-tab-panel name="retiradaTablet">
          <RetiradaTabletPin class="q-mt-md" :id="usuario.id" />
        </q-tab-panel>
      </q-tab-panels>
    </div>
    <Biometria
      :modal="biometria"
      :titulo="'Encontrar Usuário por Biometria'"
      :tipoBiometria="'verificacaoUsuario'"
    />
    <dialog-info-design
      mensagem="Deletar Imagem?"
      subMensagem="Tem certeza que deseja deletar essa imagem?"
      :exibir="deletarFacialDialog"
      :showCancelar="true"
      @resultado="deletarImagensFaciais"
    />
  </q-page>
</template>

<script>
import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import Biometria from "../../biometria/views/Biometria.vue";
import EdicaoInformacoesUsuario from "../components/EdicaoInformacoesUsuario";
import BiometriaUsuario from "../components/BiometriaUsuario";
import ComponenteBiometriaFacial from "../../../components/biometriaFacial/ComponenteBiometriaFacial";
import RetiradaTabletPin from "../components/RetiradaTabletPin";
import TabsCentrosUnidades from "../components/TabsCentrosUnidades";
import TabsTreinamentos from "../components/TabsTreinamentos.vue";
import TabsFerramentaGrupo from "../components/TabsFerramentaGrupo.vue";
import DialogInfoDesign from "../../../components/DialogInfoDesign.vue";

export default {
  components: {
    EdicaoInformacoesUsuario,
    BiometriaUsuario,
    RetiradaTabletPin,
    TabsCentrosUnidades,
    TabsTreinamentos,
    TabsFerramentaGrupo,
    Biometria,
    ComponenteBiometriaFacial,
    DialogInfoDesign,
  },
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const router = useRouter();
    const unidade = ref();
    const rightDrawerOpen = ref(false);
    const cargos = ref([]);
    const dados = ref({
      nome: "",
      id: "",
      email: "",
      centroCusto: "",
    });
    const gheDados = ref("");
    let biometria = ref(false);
    const filtroCentroCusto = ref("");
    const user = ref({
      name: "",
      email: "",
      sap: "",
      tnumber: "",
      codigo_integracao: "",
      admission_date: "",
      cargo: "",
      vendor_shift_id: "",
      roles: "",
      cost_center: "",
    });
    const tab = ref("informacoesUsuario");
    const tab2 = ref("informacoesBasica");
    const options = ref({ centros: [] });
    const time = ref();
    const centroCustoId = ref("");
    const centros = ref([]);
    const listaUsuariosOptions = ref([]);
    const usuario = ref("");
    const unidadeFiltro = ref("");
    const funcoes = ref([]);
    const loadingCentro = ref(false);
    const tabFacial = ref("cadastrarFacial");
    const faciaisCadastradas = ref([]);
    const deletarFacialDialog = ref(false);
    const facesSessionCache = ref([]);

    const getUser = async () => {
      gheDados.value = "";
      let response = await store.dispatch(
        "simplificadoStore/getUserEspecifico",
        {
          id: usuario.value.id,
        }
      );

      user.value = response.data.model;
      user.value.cost_center = response.data.model.cost_center;

      user.value.roles = response.data.model.roles[0];
      if (response.data.model.function_model != null) {
        user.value.function_model = response.data.model.function_model;
        gheDados.value = { ...user.value.function_model };
      }
      user.value.admission_date = response.data.model.admission_date
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");
      centroCustoId.value = user.value?.cost_center?.id;
      if (response.data.model.vendor_shift_id == 1) {
        user.value.vendor_shift_id = "Turno da Manhã - 06:00:00 / 12:00:00";
      } else if (response.data.model.vendor_shift_id == 7) {
        user.value.vendor_shift_id = "Turno da Noite - 19:10:00 / 21:10:00";
      }
    };

    const listarUsuarios = async (busca) => {
      const response = await store.dispatch("seguranca/listarUsuarios", {
        per_page: 15,
        search: busca,
      });
      listaUsuariosOptions.value = [];
      listaUsuariosOptions.value = response.data.results.data;
    };

    const backPage = async () => {
      console.log(usuario.value.id);
      if (usuario.value.id != undefined) {
        usuario.value = "";
        return;
      }
      router.push({ name: "spf-inicial" });
    };

    const cadastrarRoute = async () => {
      router.push({ name: "spf-user-cadastrar" });
    };

    const onUsuarioInativado = () => {
      usuario.value = "";
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    watch(
      () => usuario.value.id,
      () => {
        if (usuario.value.id == undefined) {
          return;
        }
        getUser();
        buscarFaciaisCadastradas();
      },
      { deep: true }
    );

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (rightDrawerOpen.value) {
          getCentros();
        }
      }
    );

    const atualizarUsuario = async () => {
      try {
        await store.dispatch("user/editarUser", {
          user: user.value,
          vendor_shift_id: user.value.vendor_shift_id
            ? user.value.vendor_shift_id.value
            : undefined,
          roles: user.value.roles ? user.value.roles.id : undefined,

          function_id: gheDados.value.id,
          email: user.value.email ? user.value.email : undefined,
        });

        $q.notify({
          message: "Dados atualizados com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        setRole();
        rightDrawerOpen.value = false;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o atualizar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getRoles = async () => {
      let response = await store.dispatch("user/getRoles");

      cargos.value = response.data.results.data;
    };

    const setRole = async () => {
      await store.dispatch("user/editarRoles", {
        user: user.value,
        roles: user.value.roles.id,
      });

      getUser();
    };

    const getCentros = async () => {
      try {
        loadingCentro.value = true;
        let response = await store.dispatch("user/getCentros", {
          vendor_id: unidade.value?.id,
          perPage: 10,
          search: filtroCentroCusto.value,
        });

        centros.value = response.data.results.data;
        loadingCentro.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const getFunctions = async (value) => {
      let response = await store.dispatch("user/getFuncoes", {
        vendor_id: store.state.org.unidadeData.id,
        search: value,
      });
      funcoes.value = response.data.results.data;
    };

    const receberUnidade = (value) => {
      unidadeFiltro.value = value;
      getCentros();
    };

    const indexarRegras = async () => {
      try {
        await store.dispatch("user/indexarRegras", {
          usuarios: [{ id: usuario.value.id }],
        });
        getUser();
        $q.notify({
          message: "Regras indexadas com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o indexar regras",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
        getFunctions();
        getRoles();
      }
    };

    const buscarFaciaisCadastradas = async () => {
      if (!usuario.value.id) return;

      let facesExistentes = [];
      try {
        let response = await store.dispatch("user/getBiometriaCadastrada", {
          user_id: usuario.value.id,
        });

        if (response.data.data && response.data.data.length > 0) {
          if (
            response.data.data[0].templates &&
            response.data.data[0].templates.length > 0
          ) {
            facesExistentes = response.data.data[0].templates;
          }
        }
      } catch (error) {
        console.log("Erro ao buscar faces existentes:", error);
      }

      const facesCache = facesSessionCache.value.filter(
        (face) => face.usuarioId === usuario.value.id
      );

      const todasAsFaces = [...facesExistentes];

      facesCache.forEach((faceCache) => {
        todasAsFaces.push({
          imagem_original: faceCache.imagem,
          imagemAssinada: faceCache.imagem,
          created_at: faceCache.created_at,
          id: `cache_${faceCache.id}`,
        });
      });

      faciaisCadastradas.value = todasAsFaces;
    };

    const visualizarImagemFacial = async (imageUrl, index) => {
      try {
        let assinado = await store.dispatch("user/assinarBiometriaCadastrada", {
          image_url: imageUrl,
        });

        faciaisCadastradas.value[index].imagemAssinada = assinado.data.data;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao visualizar imagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const deletarImagensFaciais = async (resultado) => {
      if (resultado) {
        try {
          await store.dispatch("user/deletarImagem", {
            userId: usuario.value.id,
          });

          $q.notify({
            message: "Biometria facial deletada com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

          buscarFaciaisCadastradas();
        } catch (error) {
          console.log(error);
          $q.notify({
            message: "Erro ao deletar biometria facial",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
      deletarFacialDialog.value = false;
    };

    const atualizarFaciaisCadastradas = async () => {
      tabFacial.value = "faciaisCadastradas";

      if (window.timeoutBuscarFaces) {
        clearTimeout(window.timeoutBuscarFaces);
      }

      window.timeoutBuscarFaces = setTimeout(async () => {
        await buscarFaciaisCadastradas();
      }, 2000);
    };

    const temPermissaoBiometria = computed(() => {
      return store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.includes(
        "voucher-auth-biometria"
      );
    });

    const temPermissaoFacial = computed(() => {
      return store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.includes(
        "vouchers-auth-facial"
      );
    });

    const temPermissaoRetiradaTablet = computed(() => {
      return store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.includes(
        "voucher-auth-cracha"
      );
    });

    onMounted(() => {
      getUnidade();
      buscarFaciaisCadastradas();
    });

    return {
      dados,
      listaUsuariosOptions,
      usuario,
      options,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarUsuarios(val);
        }, 1000);

        setTimeout(() => {
          update();
        }, 1500);
      },
      filtrarGhe(val, update) {
        getFunctions(val);
        setTimeout(() => {
          update();
        }, 500);
      },
      unidade,
      biometria,
      backPage,
      cadastrarRoute,
      getCentros,
      centros,
      tab,
      indexarRegras,
      cargos,
      user,
      getRoles,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      gheDados,
      atualizarUsuario,
      getUser,
      receberUnidade,
      rightDrawerOpen,
      centroCustoId,
      filtroCentroCusto,
      unidadeFiltro,
      loadingCentro,
      getFunctions,
      funcoes,
      tab2,
      tabFacial,
      faciaisCadastradas,
      deletarFacialDialog,
      buscarFaciaisCadastradas,
      visualizarImagemFacial,
      deletarImagensFaciais,
      atualizarFaciaisCadastradas,
      temPermissaoBiometria,
      temPermissaoFacial,
      temPermissaoRetiradaTablet,
      onUsuarioInativado,
    };
  },
};
</script>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}
.align-center {
  align-items: center;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}

.texto-titulo-input-simplificado {
  font-size: 16px;
  color: #21324a;
  font-weight: normal;
}

.mascara-usuario-modal-centro {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}

a {
  text-decoration: none;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.q-tab-panel {
  padding: 0px;
  margin: 0px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
